import { formHeaderClassNames } from "@/shared/constants/customStyleSets";

export const UpdatedPlanMessage = () => {
	return (
		<div
			className="text-light-gray h-full text-lg rounded-lg flex flex-col items-center justify-between"
			data-testid="confirm-phone-form"
		>
			<div
				className=" flex items-center flex-col justify-center mt-6 mb-6 text-center"
				data-testid="phone-form-title"
			>
				<h2 className={formHeaderClassNames}>Success!</h2>
				<p>Thank you for becoming a Premium client!</p>
			</div>
		</div>
	);
};
